import { render, staticRenderFns } from "./MultipleView.vue?vue&type=template&id=63368a79"
import script from "./MultipleView.vue?vue&type=script&lang=js"
export * from "./MultipleView.vue?vue&type=script&lang=js"
import style0 from "./MultipleView.vue?vue&type=style&index=0&id=63368a79&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports